var variant = {};
export {
  variant as __exports
};
//# sourceMappingURL=variant.js.map
